export default __webpack_public_path__ + "static/media/Picture4.15b4adad.jpg";